(() => {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialiseAnnouncement(root) {
    if (typeof root.holAnnouncementCleanup === 'function') {
      root.holAnnouncementCleanup();
    }

    const items = Array.from(root.querySelectorAll('.hol-announcement__item'));
    if (items.length < 2) return;

    let activeIndex = Math.max(items.findIndex((item) => item.classList.contains('is-active')), 0);
    let timer;

    const setActive = (index) => {
      items.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === index);
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      setActive(activeIndex);

      if (!mobileQuery.matches || reducedMotionQuery.matches || document.hidden) return;

      timer = window.setInterval(() => {
        activeIndex = (activeIndex + 1) % items.length;
        setActive(activeIndex);
      }, 3500);
    };

    const handleVisibility = () => start();

    mobileQuery.addEventListener('change', start);
    reducedMotionQuery.addEventListener('change', start);
    document.addEventListener('visibilitychange', handleVisibility);
    start();

    root.holAnnouncementCleanup = () => {
      stop();
      mobileQuery.removeEventListener('change', start);
      reducedMotionQuery.removeEventListener('change', start);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }

  function initialiseAll(scope = document) {
    scope.querySelectorAll('[data-hol-announcement]').forEach(initialiseAnnouncement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
